
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeGenericOutlined as ObiVesselTypeGenericOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-generic-outlined.js';
 
 
 

 
 export const ObiVesselTypeGenericOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-generic-outlined',
   elementClass: ObiVesselTypeGenericOutlinedElement,
   events: {
     
   }
  });
 
 